import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import ConstructionIcon from "@mui/icons-material/Construction";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "inline-flex",
    alignItems: "center",
    gap: 8,
    padding: "6px 16px",
    borderRadius: 20,
    border: `2px dashed ${theme.palette.warning.main}`,
    backgroundColor:
      theme.palette.type === "dark"
        ? "rgba(255, 152, 0, 0.12)"
        : "rgba(255, 152, 0, 0.1)",
  },
  dot: {
    width: 8,
    height: 8,
    borderRadius: "50%",
    backgroundColor: theme.palette.warning.main,
    animation: "$blink 1.5s ease-in-out infinite",
  },
  icon: {
    color: theme.palette.warning.dark,
  },
  text: {
    fontSize: "0.85rem",
    fontWeight: 800,
    color: theme.palette.warning.dark,
    textTransform: "uppercase",
    letterSpacing: "0.8px",
    whiteSpace: "nowrap",
  },
  "@keyframes blink": {
    "0%, 100%": { opacity: 1 },
    "50%": { opacity: 0.3 },
  },
}));

/**
 * BetaBadge - Selo reutilizável para indicar features em fase de testes.
 *
 * Props:
 *   label  - (opcional) texto customizado. Default: i18n "badges.beta"
 *   style  - (opcional) estilos adicionais no container
 */
const BetaBadge = ({ label, style }) => {
  const classes = useStyles();

  return (
    <span className={classes.container} style={style}>
      <ConstructionIcon style={{ fontSize: "1.2rem" }} className={classes.icon} />
      <span className={classes.dot} />
      <span className={classes.text}>
        {label || i18n.t("badges.beta")}
      </span>
    </span>
  );
};

export default BetaBadge;
